<footer>
    <div class="copyright">Copyright 2024 | Pet Poll </div>
</footer>
<style>
    footer {
        padding: 20px;
        text-align: center;
    }
    .copyright {
        color: #aaa;
        display: inline-block;
        font-size: 0.8rem;
        padding: 20px;
        border-top: 1px solid #ddd;
    }
</style>